import React from 'react';
import Meta from "../../../components/common/Meta";
import MainDesign from "../../MainDesign";
import Parents from "../../../components/user/parents/Parents";
import Heading from "../../../components/common/header/Heading";

export default function ParentsPage() {
    return <>
        <Meta
            title='Dla Rodziców | Produkacja'
            description='Dowiedz się, jak najlepiej wspierać swoje dziecko podczas Kursu Efektywnego Działania'
        />
        <MainDesign containerStyles='container py-28' removeSectionOverflowHidden={true}>
            <Heading
                title='Informacje dla rodziców'
                badgeText='Wsparcie'
                customSubtitleStyles='fs-9 fw-medium text-success'
                subtitle='Jak wspierać swoje dziecko podczas Kursu Efektywnego Działania.'
            />
            <Parents/>
        </MainDesign>
    </>
}
